import React, { Component } from 'react';
import Highcharts, { ColorAxis } from 'highcharts/highstock'
import HighchartsReact from 'highcharts-react-official'
import { withRouter } from 'react-router-dom';
import CircularProgress from '@material-ui/core/CircularProgress';
import MaterialTable from "material-table";
import { forwardRef } from 'react';
import moment from 'moment'
import 'moment/locale/es'  

import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import Chip from '@material-ui/core/Chip';
import Popover from '@material-ui/core/Popover';
import { Grid } from '@material-ui/core';

// Shared components
import PortletContent from 'components/PortletContent';
import NoActiveSection from '../../../../../helpers/NoActiveSection'
import Typography from '@material-ui/core/Typography';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {getResponseWeighted, getResponseWeightedCustom} from '../../../../../services/getWeightedResponse'
import { Button } from '@material-ui/core';
moment.locale('es')

const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};

class AvailabilityWeighted extends Component {

    constructor(props) {
        super(props);
        //console.log('weighted props',props)

        this.state = {
            objective: this.props.objective,
            token:sessionStorage.getItem("key"),
            user:sessionStorage.getItem("user"),
            dataError: false,
            isLoading: true,
            weightedList:this.props.Weighing,
            begin:this.props.begin,
            final:this.props.final,
            period:this.props.namePeriod,
            steps:this.props.steps,
            newList:[],
            weightedStepList:[]
        }
    }

    componentDidMount(){
        this.getDataFromAPI()
    }
    static getDerivedStateFromProps(props, state) {
        //console.log('derived r', props.namePeriod,state.period)
        if (props.namePeriod !== state.period || props.begin !== state.begin || props.final !== state.final) {
            return {
                objective: props.objective,
                token:sessionStorage.getItem("key"),
                user:sessionStorage.getItem("user"),
                dataError: false,
                isLoading: true,
                weightedList:props.Weighing,
                begin:props.begin,
                final:props.final,
                period:props.namePeriod,
                steps:props.steps,
                newList:[],
                open:false,
                weightedStepList:[]
            }
        
        }
        return null
    }

    componentDidUpdate(prevProps, prevState) {
        //console.log('up r', this.state.period,prevState.period )
        if(this.state.period!==prevState.period || this.props.begin !== prevState.begin || this.props.final !== prevState.final){
            //console.log('api r')
            this.getDataFromAPI();
        }
        if(this.state.newList.length===this.state.steps.length*24&&this.state.isLoading===true){   
            this.processData()
        }
        else if(this.state.newList.length===this.state.steps.length&&this.state.isLoading===true){
            this.processData()
        }
    }


    getDataFromAPI=()=>{
        const {steps, token, period, objective, user, weightedList, begin, final}=this.state
        var fetchSteps=[]
        if (period!=="c"){
            fetchSteps=getResponseWeighted(objective,period, user, token)
            
        }else{
            fetchSteps=getResponseWeightedCustom(objective,period, user, token, begin,final) 
        }
        fetchSteps.then( data =>  {
            if(data.length===1){
                this.setState({
                    dataError:true,
                    isLoading:false
                })
            }else{
                
                let copyWeightedList = [...weightedList]
                if (copyWeightedList.length === 1) {
                    const newCopyWaightedList = []
                    for (let i = 0; i < 24; i++) {
                      const result = {
                        inicio: `${(`0${i}`).substr(-2)}:00:00`,
                        termino: i === 23 ? "00:00:00":`${(`0${i+1}`).substr(-2)}:00:00`,
                        valor: 0
                      }
                      newCopyWaightedList.push(result)
                    }
                    copyWeightedList = newCopyWaightedList
                }
                steps.map(step=>{
                    Object.keys(copyWeightedList).map(key=>{
                        var inicio=(copyWeightedList[key].inicio) 
                        var final=copyWeightedList[key].termino 
                        var pond=copyWeightedList[key].valor
                        var hour=(parseInt(inicio.split(":")[0]))
                        var dataStepHour=(data[hour].dia_data[0].data)                          
                        var dia=(data[0].dia)
                        dataStepHour.map(stepHour=>{
                            if(stepHour.paso.id_paso===step.id_paso){
                            
                                var maximo = stepHour.maximo
                                var minimo = stepHour.minimo
                                var promedio = stepHour.promedio_paso
                                var cont_acumulado = stepHour.cont_acumulado
                                var timeStep = stepHour.timeStep

                                if (maximo == 0) {
                                    var maximoFiel = '-'
                                }else{
                                    maximoFiel = maximo
                                }
                                if (minimo == 0) {
                                   var minimoFiel = '-'
                                }else{
                                    minimoFiel = minimo
                                }
                                if (maximo == 0 && minimo == 0) {
                                    var promedioField = '-'
                                }else{
                                    promedioField = promedio
                                }

                                var dictStep=({"inicio":inicio, "termino":final, "ponderacion":pond, "max":maximo, "min":minimo, "prom":promedio ,"nombre_paso":stepHour.paso.nombre_paso,
                                              "id_paso":stepHour.paso.id_paso, "maximoFiel":maximoFiel, "minimoFiel":minimoFiel, "promedioField":promedioField, "cont_acumulado":cont_acumulado,
                                            "timeStep":timeStep})
                                this.setState(value=>({
                                    newList:[...value.newList, dictStep]
                                }))
                            }
                        })
                    })
                })
            }
        })
    }

    processData=()=>{
        this.setState({
            isLoading:false
            
        })
    }

    onOpenPop = (e) => {
        const {newList} = this.state
        //console.log(e.currentTarget.value)
        var min=0
        var max=0
        var prom=0
        var timeStep=0
        var contAcumulado = 0
        var minPond = 0
        var maxPond = 0
        
        newList.forEach(step=>{
            if (step.ponderacion == 0) {
                if(step.nombre_paso===e.currentTarget.value){
                    
                    if(min == 0 ){
                        min = step.min
                    }else if (step.min !== 0 && step.min < min) {
                        min = step.min
                    }

                    if(max == 0 ){
                        max = step.max
                    }else if (step.max !== 0 && step.max > max) {
                        max = step.max
                    }

                    timeStep = timeStep + step.timeStep
                    contAcumulado = contAcumulado + step.cont_acumulado
                    
                }
            }else{
                if(step.nombre_paso===e.currentTarget.value){
                    if (step.ponderacion != 0) {
                        minPond += parseFloat(((step.ponderacion/100)*step.min).toFixed(2))
                        maxPond += parseFloat(((step.ponderacion/100)*step.max).toFixed(2))
                        prom=((step.ponderacion/100)*step.prom) + prom
                    }
                    
                }
            }            
        })
        
        if (newList[0].ponderacion == 0) {
            prom = (timeStep / contAcumulado)/1000
        }

        this.setState({
            open: true,
            weightedStepList:{"step":e.currentTarget.value,"min":!minPond? min.toFixed(2):minPond.toFixed(2), 
                            "max":!maxPond? max.toFixed(2):maxPond.toFixed(2),"prom":prom.toFixed(2)}
        });
    };
    onClosePop = () => {
        this.setState({ open: false });
    };
    render() {
        const {isLoading, newList,steps, open, dataError}=this.state
        //console.log(listSteps, steps, isLoading)
        if(isLoading===true){
            return (
                <PortletContent>
                    <PerfectScrollbar style={{position:"static"}}>
                        <Typography
                            variant="h5"
                            >
                            <CircularProgress
                            variant="indeterminate"
                            size={24}
                            thickness={4}                            
                            />
                            <br/>
                            Cargando Información...
                        </Typography>
                    </PerfectScrollbar>
                </PortletContent>
            )
        }else if(dataError===true){
            return (
                <PortletContent style={{paddingBottom:"36px"}}>
                    <NoActiveSection/>
                </PortletContent>
            )
            
        }else{
            //console.log('render r', newList)
            return (
                <MaterialTable
                    icons={tableIcons}
                    columns={[
                        { title: "Paso", field: "nombre_paso",defaultGroupOrder: 0 },
                        { title: "Hora Inicio", field: "inicio"/*, type: "numeric"*/ },
                        { title: "Hora Termino", field: "termino"/*, type: "numeric"*/},
                        { title: "ponderado (%)", field: "ponderacion"/*, type: "numeric"*/},
                        { title: "minimo (s)", field: "minimoFiel"/*, type: "numeric"*/ },
                        { title: "maximo (s)", field: "maximoFiel"/*, type: "numeric"*/},
                        { title: "Promedio (s)", field: "promedioField"/*, type: "numeric"*/},
                    ]}
                    components={{
                        Toolbar: props => (
                          <div>
                            <div style={{padding: '0px 10px'}}>
                                {steps.map(step=>(
                                    <div>
                                    <Button onClick={this.onOpenPop} value={step.nombre_paso}>
                                        <Chip label={'acumulado '+step.nombre_paso} style={{marginRight: 5}}/>
                                    </Button>
                                    
                                    </div>
                                ))}
                                <Popover open={open} 
                                        onClose={this.onClosePop} 
                                        anchorOrigin={{vertical: 'center', horizontal: 'center'}}
                                        transformOrigin={{vertical: 'center', horizontal: 'center' }}>
                                            <Grid container spacing={1}>
                                                <Grid
                                                    item
                                                    sm={12}
                                                    xl={12}
                                                    xs={12}
                                                    style={{textAlign:"center"}}
                                                >
                                                    <Typography variant="h2">Total  Acumulado {this.state.weightedStepList.step}</Typography>
                                                </Grid>
                                                <Grid
                                                    item
                                                    sm={4}
                                                    xl={4}
                                                    xs={4}
                                                    style={{textAlign:"right"}}
                                                >
                                                    <Typography variant="h6">Minimo Total (s)</Typography>
                                                </Grid>
                                                <Grid
                                                    item
                                                    sm={4}
                                                    xl={4}
                                                    xs={4}
                                                    style={{textAlign:"right"}}
                                                >
                                                    <Typography variant="h6">Maximo Total (s)</Typography>
                                                </Grid>
                                                <Grid
                                                    item
                                                    sm={4}
                                                    xl={4}
                                                    xs={4}
                                                    style={{textAlign:"right"}}
                                                >
                                                    <Typography variant="h6">Promedio Total (s)</Typography>
                                                </Grid>
                                                <Grid
                                                    item
                                                    sm={4}
                                                    xl={4}
                                                    xs={4}
                                                    style={{textAlign:"right"}}
                                                >
                                                    <Typography variant="h3">{this.state.weightedStepList.min}</Typography>
                                                </Grid>
                                                <Grid
                                                    item
                                                    sm={4}
                                                    xl={4}
                                                    xs={4}
                                                    style={{textAlign:"right"}}
                                                >
                                                    <Typography variant="h3">{this.state.weightedStepList.max}</Typography>
                                                </Grid>
                                                <Grid
                                                    item
                                                    sm={4}
                                                    xl={4}
                                                    xs={4}
                                                    style={{textAlign:"right"}}
                                                >
                                                    <Typography variant="h3">{this.state.weightedStepList.prom}</Typography>
                                                </Grid>
                                                
                                            </Grid>
                                    </Popover>
                            </div>
                          </div>
                        ),
                      }}
                    data={newList}
                    title=""
                    localization={{
                        grouping: {
                            groupedBy: 'Agrupar por:',
                            placeholder: 'Arrastre los encabezados aquí, para agrupar',
                        },
                        body: {
                        emptyDataSourceMessage: 'No hay datos'
                        },
                        toolbar: {
                        searchTooltip: 'Buscar'
                        },
                        pagination: {
                        labelRowsSelect: 'Filas',
                        labelDisplayedRows: ' {from}-{to} de {count}',
                        firstTooltip: 'Pri. pág.',
                        previousTooltip: 'Pág. previa',
                        nextTooltip: 'Sig. pág.',
                        lastTooltip: 'Últ. pág'
                        }
                    }}
                    options={{
                        grouping: true
                    }}
                />
            )
        }
    }
}


export default withRouter(AvailabilityWeighted);